import {alpha, ImageList, ImageListItem, ImageListItemBar, Link, Tooltip, Typography} from "@mui/material";
import React from "react";
import 'react-lazy-load-image-component/src/effects/blur.css';
import {makeStyles} from "@mui/styles";
import PropTypes from 'prop-types';
import ImagePreview from "./ImagePreview";
import {useHistory} from "react-router-dom";
import {makeRequest} from "../../services/requestService";
import {API_URL} from "../../constants";
import LazyLoadMiniatureWithSkeleton from "./LazyLoadMiniatureWithSkeleton";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        height: '100vh',
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    item: {
        userSelect: "none",
        maxWidth: "170px",
        minHeight: "160px",
        maxHeight: "260px",
        display: "flex",
        alignItems: "center",
        border: `3px solid ${alpha(theme.palette.secondary.light, 0)}`,
        '&:hover': {
            border: '3px solid #00a6ff',
            borderRadius: '0.2em',
            cursor: "pointer",
        },
    },
}));

export default function Gallery(props) {
    const classes = useStyles();
    const {images} = props;
    const history = useHistory();

    const goToPage = (title) => {
        makeRequest(`${API_URL}/pages/byviewing?page=0&size=2&viewing=${title}`).then((response) => {
            if (response.status === 200) {
                if (response.data.totalItems > 1)
                    console.warn(title + " is not unique");
                if (response.data.totalItems > 0) {
                    history.replace({pathname: `/page/${response.data.data[0].id}`});
                } else {
                    history.replace({pathname: "/"});
                }
            }
        });
    }

    return (
        <div className={classes.root}>
            <ImageList cols={3} gap={1} sx={{overflow: "hidden"}}>
                {images.map((image) => (
                    <Tooltip key={`image-${image.title}`} title={image.title} arrow>
                        <ImageListItem
                            aria-describedby={image.title}
                            className={classes.item}
                        >
                            <Link onClick={() => goToPage(image.title)}>
                                <LazyLoadMiniatureWithSkeleton
                                    src={`${image.src}/full/!160,250/0/default.jpg`}
                                    alt={image.title}
                                />
                            </Link>
                            <ImageListItemBar
                                title={<Typography style={{fontSize: "smaller"}}>{image.title}</Typography>}
                                actionIcon={
                                    <ImagePreview color="#fff" image={image} marginLeft="512px"/>
                                }
                            />
                        </ImageListItem>
                    </Tooltip>
                ))}
            </ImageList>
        </div>
    );
}

Gallery.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
                src: PropTypes.string.isRequired,
                collection: PropTypes.string,
                title: PropTypes.string.isRequired,
                format: PropTypes.string,
                width: PropTypes.number.isRequired,
                height: PropTypes.number.isRequired,
            }
        ),
    ),
}

Gallery.defaultProps = {
    images: []
}